import React from "react";
import { arrayOf, bool, func, number, object, string } from "prop-types";

import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import More from "../../atoms/More";
import DfpContainer from "../../ads/dfp-container";
import { DfpComponent } from "../../ads/dfp-component";

import { staticTexts } from "../../utils/Translate";
import { getSlotId } from "../../utils/utils";

import "./search-stories-1ad-with-load-more.m.css";

const LoadMoreTemplateForSearch = ({
  stories = [],
  loading = false,
  onLoadMore = () => {},
  lang = "bn",
  total = 0,
}) => {
  const ads = {
    R1: {
      en: "EnPalo_ROS_336x280_R1",
      bn: "News_336x280_R1",
    },
    R2: {
      en: "EnPalo_ROS_300x250_R2",
      bn: "News_336x280_R2",
    },
    R3: {
      en: "EnPalo_ROS_336x280_R3",
      bn: "News_336x280_R3",
    },
  };

  const MoreComponent = (
    <More type="load-more" text={staticTexts(lang).more} onClick={onLoadMore} showButtonSpinner={loading} />
  );

  const adSlot = (index) =>
    global.isMobile
      ? index === 5
        ? ads.R1[lang]
        : index === 10
        ? ads.R2[lang]
        : ads.R3[lang]
      : index === 5
      ? ads.R2[lang]
      : ads.R3[lang];

  return (
    <div styleName="base">
      {stories.map((story, index) => (
        <div styleName="story-item" key={index}>
          {index !== 0 && (index % 10 === 5 || index === 5) && (
            <DfpContainer styleName="adBox">
              <DfpComponent
                type={adSlot(index)}
                slotId={getSlotId(adSlot(index), "SearchStories1AdWithLoadMore-secondAd", index / 5 + 1)}
                layoutName="SearchStories1AdWithLoadMore"
              />
            </DfpContainer>
          )}
          <LeftImageRightNews showExcerpt={global.isDesktop} key={index} story={story} widths={[180, 380, 380]} />
        </div>
      ))}

      {total > stories.length ? MoreComponent : null}
    </div>
  );
};

LoadMoreTemplateForSearch.propTypes = {
  stories: arrayOf(object),
  loading: bool,
  onLoadMore: func,
  lang: string,
  total: number,
};

export default LoadMoreTemplateForSearch;
